import React from 'react'
import { css } from '@emotion/core'
import { bpMaxMD, bpMaxSM } from '~lib/breakpoints'
import ubug from '../images/logos/head-avatar.jpg'
import Link from './link'

function BlogFooter() {
  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          paddingRight: 20,
        }}
      >
        <img
          src={ubug}
          alt="Ubug"
          css={css`
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 50%;
            ${bpMaxSM} {
              width: 40px;
              height: 40px;
            }`
          }
        />
      </div>
      <div>
        <Link to="/about/" aria-label="关于我" title="关于我" css={css`
              border-bottom: 3px solid var(--color-mark-anchor);
    box-shadow: inset 0 -4px 0 var(--color-mark-anchor);
    &:hover{
      background: var(--color-mark-anchor);
      color: inherit;
    }
              `}>
          &nbsp;Ubug&nbsp;
        </Link>
        {` 一个前端开发工程师，现居北京，主要工作是前端 + 跨端开发方向，工作目标是用高质量的技术和代码改变世界。有常年一线的开发状态，有深入的项目工程化落地经验，技术面较广，对新技术很感兴趣。兴趣广泛、想法多、喜欢折腾，把想法快速实践。`}
      </div>
    </div>
  )
}

export default BlogFooter
